import { formValueSelector, getFormSyncErrors } from 'redux-form/immutable';
import { type ErrorSelector } from 'redux-form';
import { type Moment } from 'moment';
import { type List } from 'immutable';

import { FORM_IDENTIFIER } from 'containers/DeedFormPage/constants';
import { DeedRole } from 'entities/deed/role';
import { type State } from 'reducers';

type DeedRoleFormData = DeedRole & {
  startingAt?: Moment;
  endingAt?: Moment;
};

export type DeedFormStatus = 'draft' | 'pending' | 'published';
export type DeedTypes = 'Campaign' | 'Event' | 'Project' | 'BaseEvent';

export type FormData = {
  // Added for VolunteerForm
  attendeeLimit: number;
  backgroundCheckLink: string;
  categories: unknown[];
  companyOrPublic: 'company' | 'public' | 'shared';
  sharedWithCompanies: List<string>;
  createOrganizationError: boolean | string;
  description: string;
  donationLink: string;
  donationText: string;
  duties: string;
  endingAt: Moment;
  externalLink: string;
  featured: boolean;
  fieldArrayHasErrors: unknown;
  formQuestions: unknown[];
  forms: unknown[];
  id: string;
  location: string;
  mainPicture?: string;
  mustKnows: string;
  name?: string;
  organization: unknown;
  organizerEmail: string;
  organizerName: string;
  organizerPhone: string;
  partner: string;
  partnerEmail: unknown;
  partnerName: unknown;
  pictures: string[];
  pillars: unknown[];
  public: boolean;
  roles: List<DeedRoleFormData>;
  SDGs: unknown[];
  selectOrganizationError: boolean;
  startingAt: Moment;
  status: DeedFormStatus;
  unselectOrganizationToCreateNewNonprofitError: string | boolean;
  virtual: boolean;

  // Added for CampaignForm (Fundraisers)
  nonprofits: unknown[];
  selectedPictures: unknown[];
  pledgedDonationStartingAt: string;
  pledgedDonationEndingAt: string;
  goalAmount: number;
  partnerEin: unknown;
  partnerPhone: unknown;
  partnerLocation: unknown;
};

export const valueSelector: <K extends keyof FormData>(state: State, key: K) => FormData[K] =
  formValueSelector(FORM_IDENTIFIER);

export const pickFormFields =
  <K extends keyof FormData>(fields: K[]) =>
  (state: State): Pick<FormData, K> =>
    fields.reduce(
      (acc, cur) => ({ ...acc, [cur]: valueSelector(state, cur) }),
      {} as Pick<FormData, K>
    );

export const formSyncErrors: ReturnType<ErrorSelector<FormData, State>> =
  getFormSyncErrors(FORM_IDENTIFIER);
